import { Contract } from '../../mdqx-graphql-types';
import { BackendDate } from '../../helper/backend-frontend-conversion.helper';

export class ContractEntity {
    public static readonly GqlFields = `
    abrechnungszyklus
    contractGroupTypeId
    vertragsNummer
    contractSign
    contractStatusId
    description
    endDate
    id
    name
    number
    sachkontoDebitor
    sachkontoKreditor
    startDate
    hatDiagnostik
    deleted`;


    public Abrechnungszyklus?: string | null;
    public VertragsNummer?: string | null;
    public ContractGroupTypeId: number;
    public ContractSign?: string | null;
    public ContractStatusId: number;
    public Description?: string | null;
    public EndDate?: Date | null;
    public Id: number;
    public Name?: string | null;
    public Number?: string | null;
    public SachkontoDebitor?: string | null;
    public SachkontoKreditor?: string | null;
    public StartDate?: Date | null;
    public HatDiagnostik?: boolean | null;
    public Deleted: boolean | null;

    constructor(contractType?: Contract | null) {
        if (
            contractType &&
            contractType.abrechnungszyklus !== undefined &&
            contractType.vertragsNummer !== undefined &&
            contractType.contractGroupTypeId !== undefined &&
            contractType.contractSign !== undefined &&
            contractType.contractStatusId !== undefined &&
            contractType.description !== undefined &&
            contractType.endDate !== undefined &&
            contractType.id != null &&
            contractType.name !== undefined &&
            contractType.number !== undefined &&
            contractType.sachkontoDebitor !== undefined &&
            contractType.sachkontoKreditor !== undefined &&
            contractType.startDate !== undefined &&
            contractType.hatDiagnostik !== undefined &&
            contractType.deleted !== undefined
        ) {
            this.Abrechnungszyklus = contractType.abrechnungszyklus;
            this.VertragsNummer = contractType.vertragsNummer;
            this.ContractGroupTypeId = contractType.contractGroupTypeId;
            this.ContractSign = contractType.contractSign;
            this.ContractStatusId = contractType.contractStatusId;
            this.Description = contractType.description;
            // ToDo: testen
            this.EndDate = contractType.endDate ? BackendDate(contractType.endDate) : null;
            this.Id = contractType.id;
            this.Name = contractType.name;
            this.Number = contractType.number;
            this.SachkontoDebitor = contractType.sachkontoDebitor;
            this.SachkontoKreditor = contractType.sachkontoKreditor;
            // ToDo: testen
            this.StartDate = contractType.startDate ? BackendDate(contractType.startDate) : null;
            this.HatDiagnostik = contractType.hatDiagnostik;
            this.Deleted = contractType.deleted;
        } else {
            console.error('received broken ContractType', contractType);
            throw Error();
        }
    }
}
